import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, PrismButton } from '../../components';
import { toggleAdminModal } from '../../actions/AdminActions';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AdminUserList from './AdminUserList';
import AdminTagList from './AdminTagList';
import './AdminModal.scss';

class AdminModal extends Component {
  state = { section: 0, changesSaved: true, showConfirmModal: false, clearAchievements: '', canClearAchievements: false };

  shouldCloseModal() {
    if (this.state.changesSaved && this.state.clearAchievements === '') this.props.toggleAdminModal();
    else if (this.state.clearAchievements !== '') this.setState({ clearAchievements: '', canClearAchievements: false });
  }

  shouldShowClearAchievements(name) {
    this.setState({ clearAchievements: name });
  }

  renderSection() {
    const { section, canClearAchievements } = this.state;
    switch (section) {
      case 0:
        return <AdminUserList canClear={canClearAchievements} showClearAchievements={(name) => this.shouldShowClearAchievements(name)}/>;
      case 1:
        return <AdminTagList />;
      default:
        return <div>Under construction</div>;
    }
  }

  render() {
    let maxHeight = Math.min(window.innerHeight - 160, 900);
    return (
      <div>
        <Modal
          header="Admin Tools"
          showModal={this.props.adminModalOpen}
          closeModal={() => this.shouldCloseModal()}
          className={"admin-modal"}
        >
          <div style={{ backgroundColor: 'white', maxHeight, overflow: 'auto', minHeight: 350, borderBottomLeftRadius: 19, borderBottomRightRadius: 19 }}>
            <Tabs className="prism-tabs" value={this.state.section} onChange={(e, section) => this.setState({ section })}>
              <Tab label="Manage Users" />
              <Tab label="Manage Tags" />
              {/* <Tab label="Item Three" /> */}
            </Tabs>
            <div className="admin-section-wrapper">
              {this.renderSection()}
            </div>
          </div>

        </Modal>

        <Modal header="Clear Achievements"
          showModal={this.state.clearAchievements !== ''}
          style={{ backgroundColor: 'white' }}
          closeModal={() => this.setState({ clearAchievements: '' })}
        >
          <div className="delete-confirmation-text">Are you sure you want to delete {this.state.clearAchievements}'s achievements?</div>
          <div className="confirm-leave-admin-buttons">
            <PrismButton
              style={{ backgroundColor: 'white', border: '1px solid #b1b0b0',
                color: '#4a4a4a', padding: '10px 40px', marginRight: 20
              }}
              onClick={() => this.setState({ clearAchievements: '', canClearAchievements: false })}
            >
              Cancel
            </PrismButton>
            <PrismButton
              onClick={() => {
                // this.userList.clearAchievements();
                this.setState({ clearAchievements: '', canClearAchievements: true });
              }}
              style={{ padding: '10px 40px' }}
            >
              OK
            </PrismButton>
          </div>
        </Modal>
      </div>

    );
  }
}

const mapStateToProps = ({ adminStore }) => {
  const { adminModalOpen } = adminStore;
  return { adminModalOpen };
};

export default connect(mapStateToProps, { toggleAdminModal })(AdminModal);


// WEBPACK FOOTER //
// ./src/screens/admin/AdminModal.js